export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Tags',
        category: 'User',
        description: 'Custom tags assigned by the user to games, plays, and ratings.',
        summarise: {
            prefix: 'Tag'
        },
        unit: 'tag'
    }
}